// extracted by mini-css-extract-plugin
module.exports = {"Reviews-section":"CustomerReviews_Reviews-section__2NK0y","Reviews-section--container":"CustomerReviews_Reviews-section--container__1lXho"};